// project file format icons import
import fmIcon3g2 from '../../../../assets/images/icons/file-formats/PNG/3g2.png';
import fmIcon3gp from '../../../../assets/images/icons/file-formats/PNG/3gp.png';
import fmIcon7z from '../../../../assets/images/icons/file-formats/PNG/7z.png';
import fmIconAi from '../../../../assets/images/icons/file-formats/PNG/ai.png';
import fmIconAiff from '../../../../assets/images/icons/file-formats/PNG/aiff.png';
import fmIconAvi from '../../../../assets/images/icons/file-formats/PNG/avi.png';
import fmIconBmp from '../../../../assets/images/icons/file-formats/PNG/bmp.png';
import fmIconCsv from '../../../../assets/images/icons/file-formats/PNG/csv.png';
import fmIconDoc from '../../../../assets/images/icons/file-formats/PNG/doc.png';
import fmIconDocx from '../../../../assets/images/icons/file-formats/PNG/docx.png';
import fmIconEps from '../../../../assets/images/icons/file-formats/PNG/eps.png';
import fmIconFlv from '../../../../assets/images/icons/file-formats/PNG/flv.png';
import fmIconGif from '../../../../assets/images/icons/file-formats/PNG/gif.png';
import fmIconHtml from '../../../../assets/images/icons/file-formats/PNG/html.png';
import fmIconJpg from '../../../../assets/images/icons/file-formats/PNG/jpg.png';
import fmIconJpeg from '../../../../assets/images/icons/file-formats/PNG/jpeg.png';
import fmIconJson from '../../../../assets/images/icons/file-formats/PNG/json.png';
import fmIconMov from '../../../../assets/images/icons/file-formats/PNG/mov.png';
import fmIconMp3 from '../../../../assets/images/icons/file-formats/PNG/mp3.png';
import fmIconMp4 from '../../../../assets/images/icons/file-formats/PNG/mp4.png';
import fmIconOgg from '../../../../assets/images/icons/file-formats/PNG/ogg.png';
import fmIconPdf from '../../../../assets/images/icons/file-formats/PNG/pdf.png';
import fmIconPng from '../../../../assets/images/icons/file-formats/PNG/png.png';
import fmIconPpt from '../../../../assets/images/icons/file-formats/PNG/ppt.png';
import fmIconPptx from '../../../../assets/images/icons/file-formats/PNG/pptx.png';
import fmIconPsd from '../../../../assets/images/icons/file-formats/PNG/psd.png';
import fmIconRar from '../../../../assets/images/icons/file-formats/PNG/rar.png';
import fmIconRtf from '../../../../assets/images/icons/file-formats/PNG/rtf.png';
import fmIconTxt from '../../../../assets/images/icons/file-formats/PNG/txt.png';
import fmIconUnknownFormat from '../../../../assets/images/icons/file-formats/PNG/unknown-format.png';
import fmIconWav from '../../../../assets/images/icons/file-formats/PNG/wav.png';
import fmIconWebm from '../../../../assets/images/icons/file-formats/PNG/webm.png';
import fmIconWmv from '../../../../assets/images/icons/file-formats/PNG/wmv.png';
import fmIconXls from '../../../../assets/images/icons/file-formats/PNG/xls.png';
import fmIconXlsx from '../../../../assets/images/icons/file-formats/PNG/xlsx.png';
import fmIconZip from '../../../../assets/images/icons/file-formats/PNG/zip.png';

// ==============================|| FILE FORMAT ICONS ||============================== //

const fileMngrFormatIcons = {
    '3g2': fmIcon3g2,
    '3gp': fmIcon3gp,
    '7z': fmIcon7z,
    ai: fmIconAi,
    aiff: fmIconAiff,
    avi: fmIconAvi,
    bmp: fmIconBmp,
    csv: fmIconCsv,
    doc: fmIconDoc,
    docx: fmIconDocx,
    eps: fmIconEps,
    flv: fmIconFlv,
    gif: fmIconGif,
    html: fmIconHtml,
    jpg: fmIconJpg,
    jpeg: fmIconJpeg,
    json: fmIconJson,
    mov: fmIconMov,
    mp3: fmIconMp3,
    mp4: fmIconMp4,
    ogg: fmIconOgg,
    pdf: fmIconPdf,
    png: fmIconPng,
    ppt: fmIconPpt,
    pptx: fmIconPptx,
    psd: fmIconPsd,
    rar: fmIconRar,
    rtf: fmIconRtf,
    txt: fmIconTxt,
    unknownFormat: fmIconUnknownFormat,
    wav: fmIconWav,
    webm: fmIconWebm,
    wmv: fmIconWmv,
    xls: fmIconXls,
    xlsx: fmIconXlsx,
    zip: fmIconZip
};

export default fileMngrFormatIcons;
